import { createSlice } from "@reduxjs/toolkit";

const userAirline = {};

const userAirlineSlice = createSlice({
    name: "userAirline",
    initialState: {
        userAirline,
    },
    reducers: {
        reSetuserAirline(state, action){
            state.userAirline = {}
        },
        setuserAirline(state, action) {
            state.userAirline = action.payload;
        },
    },
});


export const {
    setuserAirline,
    reSetuserAirline
} = userAirlineSlice.actions;

export default userAirlineSlice.reducer;
